function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState } from 'react';
import { AccordionArrow } from '../../@theme/assets/svg/forms';
import { AccordionContainerStyled, AccordionTitle, AccordionContent, AccordionStyled, AccordionPlanContainerStyled, AccordionMenuContainerStyled, AccordionContentMenu, AdditionalInfoTitleContainerStyled } from './styles/AccordionStyled';
var variantToComponent = {
  "default": AccordionContainerStyled,
  'plan-info': AccordionPlanContainerStyled,
  menu: AccordionMenuContainerStyled
};
var contentToComponent = {
  "default": AccordionContent,
  'plan-info': AccordionContent,
  menu: AccordionContentMenu
};
var Accordion = function Accordion(_ref) {
  var title = _ref.title,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    expanded = _ref.expanded,
    handleExpandOneAccordion = _ref.handleExpandOneAccordion,
    additionalInfoTitleContent = _ref.additionalInfoTitleContent,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleAccordionChange = function handleAccordionChange() {
    setOpen(!open);
  };
  var Component = variantToComponent[variant];
  var Content = contentToComponent[variant];
  var titleToShow = expanded ? 'OCULTAR INFORMACIÓN' : title;
  return React.createElement(Component, {
    className: className
  }, React.createElement(AccordionStyled, {
    expanded: expanded,
    square: true,
    onChange: function onChange(e, newExpanded) {
      handleAccordionChange();
      if (handleExpandOneAccordion) handleExpandOneAccordion(e, newExpanded);
    }
  }, React.createElement(AccordionTitle, {
    expandIcon: React.createElement(AccordionArrow, null)
  }, additionalInfoTitleContent ? React.createElement(AdditionalInfoTitleContainerStyled, null, React.createElement("div", null, variant !== 'plan-info' ? title : titleToShow), additionalInfoTitleContent) : React.createElement("div", null, variant !== 'plan-info' ? title : titleToShow)), React.createElement(Content, null, children)));
};
export default Accordion;